import { API_URL } from "../../constants/axios";
import { fetchApi } from "../fetch";

/**
 * 운영 사고(incident_log) — 시스템 관리자 전용. 2026-10-30.
 * 서버: IncidentAdminController(/sysadmin/incidents), KakaoGiftAdminController(/sysadmin/kakao-gift)
 *
 * 🔴 반환은 서버 응답 껍데기 `{code, data}` 를 벗긴 **payload** 다(`res.data.data`). 다른 모듈(`messages.api.js` 등)은 껍데기를
 *    돌려주고 화면이 `.data` 를 읽는데, 이 모듈의 화면(`IncidentAdmin.js`·`SystemAdminPage.js`)은 payload 를 바로 쓴다.
 *    2026-11-03: 껍데기를 그대로 돌려줘 요약·목록·건수 확인이 전부 비어 보였다.
 */
export const getIncidents = async ({ from, to, channelId, category, source, severity, unresolvedOnly = true, page = 0, size = 20 }) => {
  const params = new URLSearchParams();
  if (from) params.set("from", from);
  if (to) params.set("to", to);
  if (channelId) params.set("channelId", channelId);
  if (category) params.set("category", category);
  if (source) params.set("source", source);
  if (severity) params.set("severity", severity);
  params.set("unresolvedOnly", unresolvedOnly ? "true" : "false");
  params.set("page", String(page));
  params.set("size", String(size));
  const res = await fetchApi.get(`${API_URL.SYSTEM_INCIDENTS}?${params.toString()}`);
  return res.data?.data;
};

export const getIncidentSummary = async () => {
  const res = await fetchApi.get(`${API_URL.SYSTEM_INCIDENTS}/summary`);
  return res.data?.data;
};

export const resolveIncident = async (id, note) => {
  const res = await fetchApi.post(`${API_URL.SYSTEM_INCIDENTS}/${id}/resolve`, { note });
  return res.data?.data;
};

/** 실패한 카카오 선물 1건 재발송. 거부는 400+사유(fetch.js 가 alert). 성공 시 크레딧이 차감된다. */
export const resendKakaoGift = async (historyId) => {
  const res = await fetchApi.post(`${API_URL.SYSTEM_KAKAO_GIFT}/send-history/${historyId}/resend`, {});
  return res.data?.data;
};

/** 채널의 실패 건 일괄 재발송. dryRun=true 면 대상·예상 과금만 돌려준다. */
export const resendFailedKakaoGifts = async (channelId, dryRun = true) => {
  const res = await fetchApi.post(`${API_URL.SYSTEM_KAKAO_GIFT}/channels/${channelId}/resend-failed?dryRun=${dryRun ? "true" : "false"}`, {});
  return res.data?.data;
};

/** DDL 이전 카카오 선물 실패를 사고로 가져온다. dryRun=true 면 건수만. */
export const backfillKakaoGiftIncidents = async (since, dryRun = true) => {
  const res = await fetchApi.post(`${API_URL.SYSTEM_INCIDENTS}/backfill/kakao-gift?since=${since}&dryRun=${dryRun ? "true" : "false"}`, {});
  return res.data?.data;
};
